import { PropsWithChildren } from 'react'
import Styles from './ButtonFooter.module.scss'

type Props = PropsWithChildren

export const ButtonFooter = ({ children }: Props) => {
  return <div className={Styles.buttonFooter}>{children}</div>
}
